import {Injectable, signal} from '@angular/core';
import {MessageTelegram} from "../types/last-message.types";

@Injectable({
  providedIn: 'root'
})
export class TelegramGroupedMessagesService {
  private _groupedMessages = signal<Record<string, Array<MessageTelegram>>>({});
  private _dates = signal<Array<string>>([]);
  public groupedMessages = this._groupedMessages.asReadonly();
  public dates = this._dates.asReadonly();

  public updateMessages(messages: MessageTelegram[] | null): void {
    if (!messages) {
      this.clear();
      return;
    }

    const grouped: Record<string, MessageTelegram[]> = {};

    for (const msg of messages) {
      if (!msg.date) { continue; }

      if (msg.content) {
        const dateKey = new Date(msg.date * 1000).toLocaleDateString('ru-RU');

        if (!grouped[dateKey]) {
          grouped[dateKey] = [];
        }

        grouped[dateKey].push(msg);
      }
    }

    this._groupedMessages.set(grouped);
    this._dates.set(Object.keys(grouped));
  }

  public clear(): void {
    this._groupedMessages.set({});
    this._dates.set([]);
  }
}
